module.exports = __webpack_public_path__ + "static/media/bank-banner.54f47ff6.png";